import type { AuditTrailStatusChangeReason } from "@/api/cle-api/models/documents";

export const AUDIT_STATUS_LABELS_DA: Record<string, string> = {
  approved: "Godkendt",
  rejected: "Afvist",
  needs_review: "Kræver gennemgang",
  awaiting_review: "Afventer gennemgang",
  rejected_by_ai: "Afvist af AI",
  rejected_by_human: "Afvist manuelt",
  analyzing: "Analyseres",
  queued_for_analysis: "I kø til analyse",
  open: "Åben",
  resolved: "Løst",
};

export const AUDIT_STATUS_CHANGE_REASON_LABELS_DA: Record<
  AuditTrailStatusChangeReason,
  string
> = {
  human_review_requested: "Menneskelig gennemgang anmodet",
  thread_reopened_after_comment:
    "Gennemgang genåbnet efter ny advokatkommentar",
};

export const AUDIT_AI_DECISION_LABELS_DA: Record<string, string> = {
  approved: "Godkendt",
  rejected: "Afvist",
  needs_review: "Kræver gennemgang",
};

export const formatAuditStatusLabel = (status?: string): string | undefined => {
  if (!status) {
    return undefined;
  }

  return AUDIT_STATUS_LABELS_DA[status] ?? status.replace(/_/g, " ");
};

export const formatAuditAiDecisionLabel = (
  decision?: string,
): string | undefined => {
  if (!decision) {
    return undefined;
  }

  return AUDIT_AI_DECISION_LABELS_DA[decision] ?? decision;
};
